import typography from './typography';

/**
 * Converts pixels to rem.
 * We need this before theme object is made, it's just copy of this:
 * https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/createTypography.js
 *
 * @param {number} px Font size in pixels.
 * @returns {string} Font size in rem.
 */
const pxToRem = (px: number) =>
  `${
    (px / (typography.htmlFontSize ? typography.htmlFontSize : 16)) *
    ((typography.fontSize ? typography.fontSize : 14) / 14)
  }rem`;

export default pxToRem;
